import { render, staticRenderFns } from "./DeviceFolderTree.vue?vue&type=template&id=9b7d1ec6&"
import script from "./DeviceFolderTree.vue?vue&type=script&lang=ts&"
export * from "./DeviceFolderTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
